"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var sis_custom_select_settings_component_1 = require("./sis-custom-select-settings.component");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var SisCustomSelectComponent = /** @class */ (function () {
    function SisCustomSelectComponent() {
        this.isGrouped = false;
        this.recordDeletedPlaceHolder = '';
        this.valueChange = new core_1.EventEmitter();
        /**
         * @deprecated
         * will be removed, please use {@see isDisabled}
         */
        this.isEnabled = true;
        this.hasReset = true;
        this.width = 340;
        this._isDisabled = false;
    }
    Object.defineProperty(SisCustomSelectComponent.prototype, "isDisabled", {
        get: function () {
            return this._isDisabled;
        },
        set: function (isDisabled) {
            this._isDisabled = isDisabled === '' ? false : isDisabled;
        },
        enumerable: true,
        configurable: true
    });
    SisCustomSelectComponent.prototype.innerValueChangeHandler = function ($event) {
        this.valueChange.emit($event);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisCustomSelectComponent.prototype, "isGrouped", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisCustomSelectComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisCustomSelectComponent.prototype, "placeHolder", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisCustomSelectComponent.prototype, "name", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisCustomSelectComponent.prototype, "recordDeletedPlaceHolder", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisCustomSelectComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisCustomSelectComponent.prototype, "data", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisCustomSelectComponent.prototype, "valueChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisCustomSelectComponent.prototype, "isEnabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisCustomSelectComponent.prototype, "isreadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_crosscutting_concepts_frontend_1.MultilingualString)
    ], SisCustomSelectComponent.prototype, "hint", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisCustomSelectComponent.prototype, "hasReset", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisCustomSelectComponent.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisCustomSelectComponent.prototype, "width", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], SisCustomSelectComponent.prototype, "isDisabled", null);
    SisCustomSelectComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-custom-select',
            template: "\n\n                   <ng-container *ngIf=\"!isreadonly\">\n                       <sis-combo-box [id]=\"id\" [isDisabled]=\"isDisabled\"\n                                      (valueChange)=\"innerValueChangeHandler($event)\"\n                                      [placeHolder]=\"placeHolder\"\n                                      [recordDeletedPlaceHolder]=\"recordDeletedPlaceHolder\" [value]=\"value\"\n                                      class='sis-large-width'\n                                      [currentLanguageId]=\"currentLanguageId\" [hint]=\"hint\"\n                                      [placeHolderDefaultValueKey]=\"'de.form.please_select'\">\n                           <sis-select-items [data]=\"data\" [valueField]=\"'id'\" [nameField]=\"'name'\">\n                           </sis-select-items>\n                       </sis-combo-box>\n                   </ng-container>\n                   <ng-container *ngIf=\"isreadonly\">\n                       <label *ngIf=\"value\"\n                              [id]=\"'%{id}'\">{{name}}</label>\n                       <sis-custom-label *ngIf=\"!value\"\n                                         [key]=\"'reporting.controls.chart-designer.placeholder.noData'\"></sis-custom-label>\n                   </ng-container>\n               ",
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            groups: [
                {
                    identity: 'Controls',
                    name: 'Controls',
                },
            ],
            template: "\n                     <sis-custom-select [id]=\"'%{id}'\" [isreadonly]=\"isreadonly\" [isDisabled]=\"%{disabled}\"\n                      (valueChange)=\"%{onChange}\" [placeHolder]=\"%{placeHolder}\"\n                         [data]=\"%{dataItems}\"\n                         [currentLanguageId]=\"currentLanguageId\"\n                         [recordDeletedPlaceHolder]=\"%{recordDeletedPlaceHolder}\"\n                         [value]=\"%{field} && %{field}.getId ? %{field}.getId() : null\"\n                        [hint]=\"%{hint}\" [name]=\"actions.getClassifierName(%{field}, '%{field-category}') | async\" >\n                    </sis-custom-select>",
            iconInfo: 'fa-caret-square-o-down',
            name: 'Select',
            defaultActions: {
                'dataItems': 'loadClassifiers',
                'onChange': 'onClassifierChange',
                'recordDeletedPlaceHolder': 'getClassifierName-async'
            },
            settings: {
                main: sis_custom_select_settings_component_1.SisCustomSelectSettingsComponent
            },
            isFieldBound: false
        })
    ], SisCustomSelectComponent);
    return SisCustomSelectComponent;
}());
exports.SisCustomSelectComponent = SisCustomSelectComponent;
//# sourceMappingURL=sis-custom-select.component.js.map